module.exports = __webpack_public_path__ + "static/media/nearbuy.fa737223.jpg";